import React from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
  Divider,
  FormControl,
  FormLabel,
} from '@mui/material';
import { SoapSubjective } from '../../types/soap';

interface SubjectiveSectionProps {
  data: SoapSubjective;
  onChange: (data: SoapSubjective) => void;
  disabled?: boolean;
}

const defaultPrompts = [
  'Chief complaint/reason for visit',
  'Duration of symptoms',
  'Previous treatments',
  'Current medications',
  'Appetite and water intake',
  'Activity level changes',
];

const SubjectiveSection: React.FC<SubjectiveSectionProps> = ({
  data,
  onChange,
  disabled = false,
}) => {
  const handleAISummaryChange = (value: string) => {
    onChange({
      ...data,
      aiSummary: value,
    });
  };

  return (
    <Paper elevation={0} sx={{ p: 2, bgcolor: 'background.default' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FormControl fullWidth>
          <FormLabel sx={{ mb: 0.5, fontSize: '0.875rem', fontWeight: 'bold' }}>
            Subjective Findings
          </FormLabel>
          <TextField
            multiline
            rows={10}
            fullWidth
            value={data.aiSummary || ''}
            onChange={(e) => handleAISummaryChange(e.target.value)}
            disabled={disabled}
            placeholder="Enter subjective findings here"
            variant="outlined"
            sx={{
              '& .MuiInputBase-input': {
                fontFamily: 'monospace',
                fontSize: '0.875rem',
                lineHeight: 1.6,
              },
            }}
          />
        </FormControl>
      </Box>
    </Paper>
  );
};

export default SubjectiveSection;
